<template>
  <AppPopover
    ref="AppPopover"
    placement="top"
    @show="focusInput"
    @hide="resetInput"
  >
    <span slot="body">
      <div class="email-popover-wrapper m-5">
        <ValidationObserver ref="observer">
          <ValidationProvider
            v-slot="{ errors }"
            rules="required"
            name="workEmail"
          >
            <div
              class="form-group mb-0"
              :class="{ 'has-error': errors[0] }"
            >
              <label class="control-label">Work email</label>
              <div class="input">
                <AppInput
                  ref="workEmail"
                  v-model="workEmail"
                  :disabled="loading"
                />
              </div>
              <span class="help-block mb-0">{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
        </ValidationObserver>

        <div class="d-flex justify-content-end">
          <button
            class="submit-button"
            :disabled="loading"
            @click="applyChange"
          >
            {{ loading ? 'Applying...' : 'Apply' }}
          </button>
        </div>
      </div>
    </span>
    <span slot="trigger">
      <slot name="trigger"></slot>
    </span>
  </AppPopover>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'WorkEmailPopover',
  props: {
    member: {
      type: Object,
      required: true,
    },
    organizationId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      workEmail: this.member.user.email,
    };
  },
  methods: {
    ...mapActions(['updateEmail']),
    close() {
      this.$refs.AppPopover.close();
    },
    async applyChange() {
      if (this.loading) {
        return;
      }

      const validated = await this.$refs.observer.validate();

      if (validated) {
        this.loading = true;

        this.updateEmail({ id: this.member.id, user: { email: this.workEmail } }).then(
          this.completeRequest,
          this.handleErrors,
        );
      }
    },
    completeRequest(response) {
      this.loading = false;

      if (response && response.success) {
        this.handleSuccess();
      } else {
        const resp = response ? response.error : 'Email was not updated';

        this.handleErrors(resp);
      }
    },
    handleSuccess() {
      this.$appMessage('Email updated');
      this.close();
    },
    handleErrors(response) {
      this.$refs.observer.setErrors({
        workEmail: response
          .substring(response.indexOf(':') + 1)
          .trim()
          .replace(/^[A-Z][a-z]*\s*/, ''),
      });
      this.$appMessage(response);
    },
    focusInput() {
      setTimeout(() => {
        this.$refs.workEmail.focus();
      }, 10);
    },
    resetInput() {
      this.$refs.observer.reset();
    },
  },
};
</script>
